var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "box" }, [
    _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Mis datos")]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-1" }, [
      _c("span", { staticClass: "is-uppercase" }, [
        _vm._v(_vm._s(_vm.user.apellido)),
      ]),
      _vm._v(", " + _vm._s(_vm.user.nombre)),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("CUIL")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v(_vm._s(_vm.user.cuil))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Email")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v(_vm._s(_vm.user.email))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Mi organización")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v(_vm._s(_vm.organization.razon_social))]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("CUIT Org.")]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [_vm._v(_vm._s(_vm.organization.cuit))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Mis Roles")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tags" },
          [
            _vm._l(_vm.user.roles, function (role, index) {
              return _c("p", { key: index, staticClass: "tag" }, [
                _vm._v(_vm._s(role.descripcion)),
              ])
            }),
            _vm._v(" "),
            _vm.user.roles.length == 0
              ? _c("p", [_c("i", [_vm._v("No hay roles asignados")])])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Mis areas")]),
        _vm._v(" "),
        _vm.user.areas.length > 0
          ? _c(
              "div",
              { staticClass: "field is-grouped is-grouped-multiline" },
              _vm._l(_vm.user.areas, function (area, index) {
                return _c("div", { key: index, staticClass: "control" }, [
                  _c("div", { staticClass: "tags has-addons" }, [
                    _c("p", { staticClass: "tag is-dark" }, [
                      _vm._v(_vm._s(area.nombre)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "tag" }, [
                      _vm._v(_vm._s(area.pivot.cargo)),
                    ]),
                  ]),
                ])
              }),
              0
            )
          : _c("p", [_c("i", [_vm._v("No hay areas asignadas")])]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }